export type SuccessIconProps = {
    height?: number;
    width?: number;
};

const SuccessIcon = ({ height = 60, width = 64 }: SuccessIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="4" fill="none" />
            <path
                d="M20 32L28 40L44 24"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SuccessIcon;

